module.exports = __webpack_public_path__ + "img/shield_3.bd4276ee.png";